import React from 'react'

import {
    TYPE_PADDING,
    TYPE_MARGIN,
    TYPE_BACKGROUND_COLOR,
    TYPE_BACKGROUND_POSITION,
    TYPE_BACKGROUND_SIZE,
    TYPE_BACKGROUND_REPEAT,
    TYPE_BACKGROUND_LOADING_METHOD,
    TYPE_BACKGROUND_MODE,
    BACKGROUND_MODE_IMAGE_FLAG,
    BACKGROUND_MODE_VIDEO_FLAG,
    TYPE_BORDER_X,
    TYPE_BORDER_Y,
    TYPE_BORDER_COLOR,
    TYPE_BORDER_STYLE,
    TYPE_ANIMATION_STYLE,
    TYPE_ANIMATION_HOVER,
} from '../const'

let values = []

for (let i = 0; i <= 200; i += 5) {
    values.push({ label: i, value: i })
}

export const paddingOptions = values

export const marginsOptions = values

export const backgroundColorOptions = [{ label: 'None', value: 'transparent' }]

export const backgroundPositionOptions = [
    { label: 'Centre', value: 'center' },
    { label: 'Top', value: 'center top' },
    { label: 'Bottom', value: 'center bottom' },
    { label: 'Left', value: 'left center' },
    { label: 'Right', value: 'right center' },
]

export const backgroundSizeOptions = [
    { label: 'Initial', value: 'initial' },
    { label: 'Cover', value: 'cover' },
    { label: 'Contain', value: 'contain' },
]

export const backgroundRepeatOptions = [
    { label: 'None', value: 'no-repeat' },
    { label: 'Both', value: 'both' },
    { label: 'Horizontal', value: 'repeat-x' },
    { label: 'Vertical', value: 'repeat-y' },
]

export const backgroundModeOptions = [
    { label: 'Image', value: BACKGROUND_MODE_IMAGE_FLAG },
    { label: 'Video', value: BACKGROUND_MODE_VIDEO_FLAG },
]

export const backgroundLoadingMethodOptions = [
    { label: 'Normal', value: 'normal' },
    { label: 'Preload', value: 'preload' },
]

export const borderXOptions = [
    { label: 'None', value: 'none' },
    { label: 'Both', value: 'both' },
    { label: 'Left', value: 'left' },
    { label: 'Right', value: 'right' },
]

export const borderYOptions = [
    { label: 'None', value: 'none' },
    { label: 'Both', value: 'both' },
    { label: 'Top', value: 'top' },
    { label: 'Bottom', value: 'bottom' },
]

export const borderColorOptions = [{ label: 'Default', value: 'rgba(0,0,0,0.1)' }]

export const borderStyleOptions = [
    { label: 'Solid', value: 'solid' },
    { label: 'Dashed', value: 'dashed' },
    { label: 'Dotted', value: 'dotted' },
]

export const animationStyleOptions = [
    { label: 'None', value: 'none' },

    { label: 'Fade In', value: 'fade' },
    { label: 'Fade Left', value: 'fade-left' },
    { label: 'Fade Right', value: 'fade-right' },
    { label: 'Fade Up', value: 'fade-top' },
    { label: 'Fade Down', value: 'fade-bottom' },

    { label: 'Slide Left', value: 'slide-left' },
    { label: 'Slide Right', value: 'slide-right' },
    { label: 'Slide Up', value: 'slide-top' },
    { label: 'Slide Down', value: 'slide-bottom' },

    { label: 'Zoom In', value: 'zoom' },
    { label: 'Zoom Left', value: 'zoom-left' },
    { label: 'Zoom Right', value: 'zoom-right' },
    { label: 'Zoom Up', value: 'zoom-top' },
    { label: 'Zoom Down', value: 'zoom-bottom' },

    { label: 'Bounce In', value: 'bounce' },
    { label: 'Bounce Left', value: 'bounce-left' },
    { label: 'Bounce Right', value: 'bounce-right' },
    { label: 'Bounce Up', value: 'bounce-top' },
    { label: 'Bounce Down', value: 'bounce-bottom' },
]

export const animationHoverOptions = [
    { label: 'None', value: 'none' },
    { label: 'Zoom', value: 'zoom' },
]

export const defaultTranslations = {
    backgroundColorInput: 'Background colour',
    backgroundColorOpacityInput: 'Background colour opacity',
    backgroundImageInput: 'Background image',
    backgroundPositionInput: 'Background position',
    backgroundSizeInput: 'Background size',
    backgroundRepeatInput: 'Background repeat',
    backgroundModeInput: 'Background mode',
    backgroundVideoInput: 'Background video',
    backgroundPosterframeInput: 'Background video posterframe',
    backgroundLoadingMethodInput: 'Background loading method',
    backgroundAltTextInput: 'Background image alt text',

    borderXInput: 'X-axis Display',
    borderYInput: 'Y-axis Display',
    borderColorInput: 'Border colour',
    borderWidthInput: 'Border width',
    borderStyleInput: 'Border style',

    animationStyleInput: 'Animation style',
    animationDurationInput: 'Animation duration',
    animationDelayInput: 'Animation delay',

    anchorIdInput: 'Anchor ID',
}

export const defaultSettings = {
    DecoratorComponent: <>There is no decorator component</>,
    DecoratorFormComponent: null,

    options: {
        [TYPE_PADDING]: paddingOptions,
        [TYPE_MARGIN]: marginsOptions,
        [TYPE_BACKGROUND_COLOR]: backgroundColorOptions,
        [TYPE_BACKGROUND_POSITION]: backgroundPositionOptions,
        [TYPE_BACKGROUND_SIZE]: backgroundSizeOptions,
        [TYPE_BACKGROUND_REPEAT]: backgroundRepeatOptions,
        [TYPE_BACKGROUND_LOADING_METHOD]: backgroundLoadingMethodOptions,
        [TYPE_BACKGROUND_MODE]: backgroundModeOptions,

        [TYPE_BORDER_X]: borderXOptions,
        [TYPE_BORDER_Y]: borderYOptions,
        [TYPE_BORDER_COLOR]: borderColorOptions,
        [TYPE_BORDER_STYLE]: borderStyleOptions,

        [TYPE_ANIMATION_STYLE]: animationStyleOptions,
        [TYPE_ANIMATION_HOVER]: animationHoverOptions,
    },

    translations: defaultTranslations,
    decoratePlugins: plugins => plugins,
}
